import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import { GrDrag } from "react-icons/gr";
import { HiOutlineArrowNarrowDown } from "react-icons/hi";
import SelectAction from "../../../actions/selectaction";
import EditAction from "../../../actions/editaction";
import useActions from "../../../utils/useactions";
import { useDrop, useDrag } from "react-dnd";
import AddAction from "./addaction";
import ActionCard from "./actioncard";

export default function Opperation({
  opperation,
  path,
  onClick,
  sources,
  onChange,
  onDelete,
  index,
  onDrop,
  actions,
  types,
}) {
  const handleChildUpdate = (v, index) => {
    const _opperation = { ...opperation };
    _opperation.children[index] = v;
    onChange(_opperation);
  };

  const handleDrop = (item, monitor) => {
    if (!monitor.isOver({ shallow: true })) {
      return;
    }
    onDrop(item.action, item.path, path);
  };

  const [{ dragging }, dragRef, preview] = useDrag({
    item: {
      type: "action",
      path: path,
      index: index,
      action: { ...opperation },
    },
    collect: (monitor, props) => ({
      dragging: monitor.isDragging(),
    }),
  });

  const [{ hovered }, dropRef] = useDrop({
    accept: "action",
    drop: handleDrop,
    //canDrop: (item, montior) => item.index !== index,
    collect: (monitor) => ({
      hovered: !!monitor.isOver({ shallow: true }) && monitor.canDrop(),
    }),
  });
  return (
    <div
      ref={dropRef}
      style={{ width: "fit-content", display: dragging ? "none" : "block" }}
    >
      <div className={styles.opperationContainer}>
        <div ref={dragRef} onClick={onClick} className={styles.opperation}>
          <div>{opperation.name}</div>
          <GrDrag
            style={{ fontSize: 24, color: "var(--main)", cursor: "move" }}
          />
        </div>
        <div className={styles.childContainer}>
          {opperation.children.map((c, index) => {
            return (
              <OpperationChild
                onChange={(v) => handleChildUpdate(v, index)}
                onDrop={onDrop}
                sources={sources}
                path={[...path, "children", index]}
                child={c}
                key={c.id}
                actions={actions}
                types={types}
              />
            );
          })}
        </div>
        <div onClick={onDelete} className={styles.deleteOpp}>
          delete
        </div>
      </div>
      <div
        style={{
          color: "#333",
          fontSize: 24,
          marginTop: 8,
          marginLeft: "auto",
          marginRight: "auto",
          width: "fit-content",
          marginBottom: hovered ? 42 : 0,
        }}
      >
        <HiOutlineArrowNarrowDown />
      </div>
    </div>
  );
}

const OpperationChild = ({
  child,
  sources,
  onChange,
  actions,
  types,
  path,
  onDrop,
}) => {
  const [selected, setSelected] = useState(null);
  const [_open, setOpen] = useState(false);
  const [returnSources, setReturnSources] = useState([]);

  const handleSelect = (action) => {
    const actions = [...child.actions];
    actions.push(action);
    const _child = { ...child, actions: actions };
    onChange(_child);
    setOpen(false);
    if (!action.children) setSelected(action);
  };

  const handleUpdate = (action) => {
    const findIndex = child.actions.findIndex((x) => x.id === action.id);
    const actions = [...child.actions];
    actions[findIndex] = action;
    const _child = { ...child, actions: actions };
    onChange(_child);
    setSelected(null);
  };

  const topDrop = (item, monitor) => {
    if (!monitor.isOver({ shallow: true })) {
      return;
    }
    onDrop(item.action, item.path, [...path, "actions", -1]);
  };

  const handleDelete = (index) => {
    const actions = [...child.actions];
    actions.splice(index, 1);
    const _child = { ...child, actions: actions };
    onChange(_child);
  };
  useEffect(() => {
    if (selected) {
      const findIndex = child.actions.findIndex((x) => x.id === selected.id);
      console.log("findIndex ", findIndex);

      if (findIndex < 0) {
        setReturnSources([]);
        return;
      }

      const sources = [];
      child.actions.forEach((action, i) => {
        if (action.return && i < findIndex) {
          action.return.forEach((r) => {
            console.log("return ", r);
            sources.push({
              name: `${action.name}'s ${r.name}`,
              code: `_${i}.${r.name}`,
              params: [],
              returnType: r.type,
              returnList: r.list,
            });
          });
        }
      });
      setReturnSources(sources);
    } else {
      setReturnSources([]);
    }
  }, [selected, child]);

  const [{ hovered }, dropRef] = useDrop({
    accept: "action",
    drop: topDrop,
    collect: (monitor) => ({
      hovered: !!monitor.isOver() && monitor.canDrop(),
    }),
  });
  return (
    <div className={styles.opperationChild}>
      <div ref={dropRef} className={styles.childStart}>
        {child.displayName}
      </div>
      <HiOutlineArrowNarrowDown
        style={{
          fontSize: 24,
          margin: "8px 0px",
          marginBottom: hovered ? 50 : 8,
        }}
      />
      {child.actions.map((a, i) => {
        if (a.children) {
          return (
            <Opperation
              onChange={handleUpdate}
              key={a.id}
              sources={sources}
              opperation={a}
              path={[...path, "actions", i]}
              onDelete={() => handleDelete(i)}
              onDrop={onDrop}
              index={i}
            />
          );
        }
        return (
          <ActionCard
            key={a.id}
            onDrop={onDrop}
            action={a}
            path={[...path, "actions", i]}
            index={i}
            onClick={() => setSelected(a)}
            onDelete={() => handleDelete(i)}
            horizontal
          />
        );
      })}
      <AddAction onClick={() => setOpen(true)} />
      <EditAction
        action={selected}
        onSave={handleUpdate}
        actions={actions}
        onClose={() => setSelected(false)}
        sources={[...returnSources, ...sources]}
      />
      <SelectAction
        open={_open}
        onClose={() => setOpen(false)}
        onSelect={handleSelect}
        actions={actions}
        types={types}
      />
    </div>
  );
};
